import script from "./PersonalVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalVideo.vue?vue&type=script&setup=true&lang=js"

import "./PersonalVideo.vue?vue&type=style&index=0&id=0ca7bb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca7bb1a"]])

export default __exports__